// extracted by mini-css-extract-plugin
export default {"container":"ManagementAreaTypeFilter_container__B2gWZ","content":"ManagementAreaTypeFilter_content__3m9j1"};